"use client";

import { RegistrationOptionCard, RegistrationOptionCardProps } from "@features/registration";
import { useClientConfig } from "@providers/app-provider/client-app-provider";

export function WlkpRegistrationOptionCard(props: Omit<RegistrationOptionCardProps, "externalHref" | "href">) {
  const config = useClientConfig();

  const wlkpLink = config?.config.wlkpAppUrl;

  return <RegistrationOptionCard {...props} externalHref={`${wlkpLink}/register`} />;
}
